<rt-box variant="vertical">
  @for (job of jobs; track trackByAsyncJob($index, job)) {
    <rt-async-jobs-progress-display [title]="job.title" [job]="job">
    </rt-async-jobs-progress-display>

    @if (job.done && job.errors.length > 0) {
      <div class="errors" margin-top padding>
        <ul>
          @for (error of job.errors; track trackByError($index, error)) {
            <li>{{ error }}</li>
          }
        </ul>
      </div>
    }

    <rt-divider margin-tb></rt-divider>
  }

  <div layout-horizontal layout-justify-center>
    <rt-button (click)="dialogRef.close(true)" variant="tertiary" margin-top-small>
      {{
        allCompleted
          ? ('app.background_job_progress.hide' | translate)
          : ('app.common.close' | translate)
      }}
    </rt-button>
  </div>
</rt-box>
